<template>
  <div class="overflow-y-scroll">
    <h3>Edit Profile</h3>
    <section>
      <div class="form-inline">
        <label>Name:</label>
        <div>
          <input type="text" placeholder="Name" v-model="editName" />
        </div>
      </div>
      <div class="form-inline">
        <label>Active:</label>
        <div>
          <model-select
            :options="activeOptions"
            v-model="editIsActive"
            placeholder="Active"
          ></model-select>
        </div>
      </div>
      <div class="form-inline" v-show="user.roles.admin">
        <label>Email:</label>
        <div>
          <input type="text" placeholder="Email" v-model="editEmail" />
        </div>
      </div>
      <div class="form-inline">
        <label>Phone Number:</label>
        <div>
          <input
            type="text"
            placeholder="Phone Number"
            v-model="editPhoneNumber"
          />
        </div>
      </div>
      <div class="form-inline">
        <label>Title:</label>
        <div>
          <input type="text" placeholder="Title" v-model="editTitle" />
        </div>
      </div>
      <div class="form-inline">
        <label>Metro:</label>
        <div>
          <model-select
            :options="metroOptions"
            v-model="editMetro"
            placeholder="Metro"
          ></model-select>
        </div>
      </div>
      <div class="form-inline">
        <label>Address:</label>
        <div>
          <input type="text" placeholder="Address" v-model="editAddress" />
        </div>
      </div>
      <div class="form-inline" v-show="user.roles.admin">
        <label>Stripe Id:</label>
        <div>
          <input type="text" placeholder="Stripe Id" v-model="editStripeId" />
        </div>
      </div>
      <div class="form-inline" v-show="user.roles.admin">
        <label>Rate:</label>
        <div>
          <input type="text" placeholder="Rate" v-model="editRate" />
        </div>
      </div>
      <div class="form-inline" v-show="user.roles.admin">
        <label for="rateType">Rate Type:</label>
        <div>
          <model-select
            :options="rateTypeOptions"
            v-model="editRateType"
            placeholder="RateType"
          ></model-select>
        </div>
      </div>
      <div class="form-inline">
        <label>Work Type:</label>
        <div class="test">
          <multi-select
            :options="workTypeOptions"
            :selected-options="editWorkType"
            @select="onSelectWorkType"
            placeholder="WorkType"
          ></multi-select>
        </div>
      </div>
      <div class="form-inline" v-show="user.roles.admin">
        <label>Application Status:</label>
        <div>
          <model-select
            :options="applicationStatusOptions"
            v-model="editApplicationStatus"
            placeholder="Application Status"
          ></model-select>
        </div>
      </div>
      <div class="form-inline">
        <label>Tech Level:</label>
        <div>
          <model-select
            :options="techLevelOptions"
            v-model="editTechLevel"
            placeholder="Tech Level"
          ></model-select>
        </div>
      </div>
      <div class="form-inline">
        <label>Bio:</label>
        <div>
          <textarea rows="3" placeholder="Bio" v-model="editBio" />
        </div>
      </div>
      <div class="form-inline">
        <spinnerButton
          class="submit primary"
          :loading="submitLoading"
          @click.native="buttonClick"
          >Edit Profile</spinnerButton
        >
      </div>
    </section>
  </div>
</template>

<script>
import { ModelSelect, MultiSelect } from "vue-search-select";
import "vue-search-select/dist/VueSearchSelect.css";
import { db } from "@/vendor/firebase";
import { mapState } from "vuex";
import * as utils from "@/utils/utils";
import spinnerButton from "@/components/public/SpinnerButton";
import * as constant from "@/constant/constant";

export default {
  props: ["propsData", "submitLoading"],
  components: {
    ModelSelect,
    spinnerButton,
    MultiSelect,
  },
  data() {
    return {
      editName: null,
      editIsActive: null,
      editEmail: null,
      editPhoneNumber: null,
      editTitle: null,
      editMetro: null,
      editAddress: null,
      editRate: null,
      editRateType: null,
      editStripeId: null,
      editBio: null,
      editWorkType: [],
      editApplicationStatus: null,
      editTechLevel: null,

      activeOptions: [
        { text: "Active", value: true },
        { text: "Inactive", value: false },
      ],
      metroOptions: [],
      applicationStatusOptions: [],
      techLevelOptions: [],
      workTypeOptions: [],
      rateTypeOptions: [
        { value: null, text: "null" },
        { value: "only full-time", text: "only full-time" },
        { value: "only part-time", text: "only part-time" },
      ],
    };
  },
  computed: {
    ...mapState(["user"]),
  },
  created: function () {
    this.initOptions();
    this.initData();
  },
  methods: {
    initOptions: function () {
      this.initMetroOptions();
      this.initApplicationStautsOptions();
      this.initTechLevelOptions();
      this.initWorkTypeOptions();
    },
    initMetroOptions: function () {
      let metrosArray = [];
      db.collection("metros")
        .get()
        .then((querySnapshot) => {
          const documents = querySnapshot.docs.map((doc) => doc.data());
          documents.forEach((metro, index) => {
            metrosArray.push({
              text: metro.name,
              value: metro.name,
            });
          });
          this.metroOptions = metrosArray;
        });
    },
    initWorkTypeOptions: function () {
      const workTypeArray = [];
      db.collection("new_work_types")
        .get()
        .then((querySnapshot) => {
          const documents = querySnapshot.docs.map((doc) => doc.data());
          documents.forEach((workType, index) => {
            workTypeArray.push({
              text: workType.name,
              value: workType.name,
            });
          });
          this.workTypeOptions = workTypeArray;
        });
    },
    initApplicationStautsOptions: function () {
      const applicationStatusArray = [];
      constant.APPLICATION_STATUSES.forEach((item) => {
        applicationStatusArray.push({ text: item, value: item });
      });
      applicationStatusArray.push({ text: "null", value: null });
      this.applicationStatusOptions = applicationStatusArray;
    },
    initTechLevelOptions: function () {
      const techLevelArray = [];
      db.collection("tech_levels")
        .get()
        .then((querySnapshot) => {
          const documents = querySnapshot.docs.map((doc) => doc.data());
          documents.forEach((techLevel, index) => {
            techLevelArray.push({
              text: techLevel.name,
              value: techLevel.name,
            });
          });
          techLevelArray.push({ text: "null", value: null });
          this.techLevelOptions = techLevelArray;
          this.techLevelOptions.sort((a, b) => {
            if (a.order === null || a.order === undefined) return 1;
            if (b.order === null || b.order === undefined) return -1;
            return a.order - b.order;
          });
        });
    },
    initData: function () {
      this.editName = this.propsData.name;
      this.editIsActive = {
        text: this.propsData.is_active ? "Active" : "Inactive",
        value: this.propsData.is_active ? true : false,
      };
      this.editEmail = this.propsData.email;
      this.editPhoneNumber = this.propsData.phone_number;
      this.editTitle = this.propsData.title;
      this.editMetro = {
        text: this.propsData.metro,
        value: this.propsData.metro,
      };
      // this.editWorkType = {
      //   text: this.propsData.work_type,
      //   value: this.propsData.work_type,
      // };
      this.editWorkType = (this.propsData.work_type || "")
        .split(",")
        .filter((item) => item)
        .map((item) => ({
          text: item,
          value: item,
        }));
      this.editApplicationStatus = {
        text: this.propsData.application_status,
        value: this.propsData.application_status,
      };
      this.editTechLevel = this.propsData.tech_level;
      this.editAddress = this.propsData.address;
      this.editRate = this.propsData.rate;
      this.editStripeId = this.propsData.stripe_id;
      this.editBio = this.propsData.bio;
      this.editRateType = this.propsData.rate_type
        ? this.propsData.rate_type
        : null;
    },
    buttonClick: function () {
      const data = {
        name: this.editName ? this.editName : null,
        is_active: this.editIsActive.value ? true : false,
        email: this.editEmail ? this.editEmail.trim().toLowerCase() : null,
        phone_number: this.editPhoneNumber
          ? utils.parsePhoneNumber(this.editPhoneNumber)
          : null,
        title: this.editTitle ? this.editTitle : null,
        metro: this.editMetro.value ? this.editMetro.value : null,
        address: this.editAddress ? this.editAddress : null,
        rate: this.editRate ? utils.toNumber(this.editRate) : null,
        rate_type: this.editRateType,
        stripe_id: this.editStripeId ? this.editStripeId : null,
        bio: this.editBio ? this.editBio : null,
        // work_type: this.editWorkType.value ? this.editWorkType.value : null,
        work_type: (this.editWorkType || [])
          .map((item) => item.value)
          .join(","),
        application_status: this.editApplicationStatus.value
          ? this.editApplicationStatus.value
          : null,
        tech_level: this.editTechLevel ? this.editTechLevel : null,
      };
      this.$emit("buttonClick", data);
    },
    onSelectWorkType(items, lastSelectItem) {
      this.editWorkType = items;
    },
  },
};
</script>
